import React from "react";
import SustainabilityBlock from "../components/Sustainability/SustainabilityBlock";
export default function VentureCapital() {
    return (
        <section>
            <SustainabilityBlock/>
        </section>



    );
}